import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { PageTemplate } from '@/components/templates'
import { CONTAINER_SIZES } from '@/constants'
import OrderbookTable from '@/components/orderbook/OrderbookTable'
import { useOTC } from '@/hooks/useOTC'
import { useOtcStats } from '@/hooks/useOTC'
import { OTCMetricsCards } from '@/components/molecules/OTCMetricsCards'
import { useIsMobile } from '@/hooks/use-mobile'

const OTCScreen: React.FC = () => {
  const navigate = useNavigate()
  const isMobile = useIsMobile()
  const { data: stats, loading: statsLoading } = useOtcStats()
  const [countdown, setCountdown] = useState(20)

  // Countdown timer for data refresh
  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) return 20
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return (
    <PageTemplate
      maxWidth={CONTAINER_SIZES.WIDE}
    >
      <div className="relative space-y-4 pt-0 md:pt-5">
        {/* Header Section */}
        <div className="mb-6 md:mb-7">
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <h1 
                className="font-plus-jakarta text-[#2D2923] dark:text-[#fdfdfd] text-[23px] leading-[32px] md:text-[30px] md:leading-[40px] font-semibold tracking-[-0.2px] md:tracking-[-0.28px] mb-0"
                style={{ fontFeatureSettings: "'liga' off, 'clig' off" }}
              >
                Secondaries Trading
              </h1>
              <p 
                className="w-full md:w-[385px] font-plus-jakarta text-[rgba(45,41,35,0.64)] dark:text-[rgba(253,253,253,0.72)] text-[14px] leading-[20px] md:text-[16px] md:leading-[24px] font-normal"
                style={{ fontFeatureSettings: "'liga' off, 'clig' off" }}
              >
                Trade secondaries with institutional liquidity
              </p>
            </div>
            {!isMobile && (
              <div className="ml-4 mt-[64px] flex-shrink-0 font-plus-jakarta text-[12px] font-medium leading-[16px] text-[rgba(45,41,35,0.64)] dark:text-[rgba(253,253,253,0.72)]">
                Next update: {countdown}s
              </div>
            )}
          </div>
        </div>

        {/* Metrics Cards */}
        <OTCMetricsCards 
          stats={stats} 
          loading={statsLoading}
        />
        
        {/* Orders Table */}
        <OrderbookTable
          title="Secondaries Orders"
          navigate={navigate}
          useDataHook={useOTC}
          dataKey="orders"
          showPagination={false}
          showSummary={false}
          useUrlParams={true}
          showOrderInquiry={true}
        />
      </div>
    </PageTemplate>
  )
}

export default OTCScreen 
